import React, { useState } from 'react';
import { useEffect } from 'react';
import SalePackages from '../../SalePackagesBlock/SalePackages';
import { Container, Row } from 'reactstrap';
import BtnSelect from '../../../Shared/Buttons/BtnSelect';
import RadioInput from '../../../Shared/RadioInput/RadioInput';
import { INPUT_TYPE, planSelectionRadioEnums } from '../IdfSaleEnums';
import TextInput from '../../../Shared/TextInput/TextInput';
import Buttons from '../Constans/Buttons';
import { IsCellcomNumber, IsExternalCompanyNumber } from '../IdfSaleSlice';
import { connect } from 'react-redux';
import PopUp from '../../../Shared/Popup/PopUp';
import PhoneNumberErrorPopUp from '../PopUps/PhoneNumberErrorPopUp';
import { validateInput } from '../Constans/Validation';
import { dwhReport, dwhDictionary } from '../dwhReports/dwhGeneralReport'
import { isNullOrEmpty } from 'app/utilities/StringHelpers/StringHelpers';
const PlanSelection = (props) => {
  const [canContinue, setCanContinue] = useState(false);
  const [plan, setPlan] = useState(props.idfStore.lineType);
  const [showPopup, setShowPopup] = useState(false);
  const [response, setResponse] = useState(null);
  const funding = props.idfStore.userDetails.amount_of_funding;
  const { user_type_id: userType } = props.idfStore.userDetails;
  const packagesByUserType =
    userType === 'Regular' ? props.contentData.salePackages.expandedValue : props.contentData.salePackagesPremium.expandedValue;
  const packages = packagesByUserType.filter((p) => p.isActivePackage.value == true);
  const packagesPostFunding =
    packages?.length > 0 &&
    packages.map((p) => {
      if (funding != null && funding && p.price.value - funding > 0) {
        return { ...p, price: { ...p.price, value: (p.price.value - funding).toFixed(2) } };
      } else {
        return { ...p, price: { ...p.price, value: 0 } };
      }
    });
  useEffect(() => {
    if (packages?.length == 1) {
      const salePackage = {
        blockID: packages[0].contentLink.id,
        offerID: packages[0].offerID.value,
        link: packages[0].link.value,
        title: packages[0].title.value,
        subTitle: packages[0].subTitle.value,
        price: packagesPostFunding[0].price?.value,
        addons: packages[0].addons?.expandedValue,
      };
      onSelectedPackages(salePackage);
    }
  }, []);

  useEffect(() => {
    if (props.idfStore.selectedPackage != null) {
      if (props.idfStore.lineType !== '') {
        if (props.idfStore.lineType !== planSelectionRadioEnums.INTRESTED_IN_NEW_LINE.value) {
          if (props.idfStore.lineNumber !== '') {
            setCanContinue(true);
          } else {
            setCanContinue(false);
          }
        } else {
          setCanContinue(true);
        }
      }
    }
  }, [props.idfStore.selectedPackage, props.idfStore.lineType, props.idfStore.lineNumber]);

  const onContinue = async () => {
    var phoneNumber = plan == planSelectionRadioEnums.INTRESTED_IN_NEW_LINE.value ?
      '0' + props.idfStore.userDetails.new_line_code :
      props.idfStore.lineNumber;

    const isPhoneNumberValid = validateInput(phoneNumber, INPUT_TYPE.PHONE);
    let res;

    if (phoneNumber != null && isPhoneNumberValid) {
      switch (plan) {
        case planSelectionRadioEnums.HAS_LINE_IN_CELLCOM.value:
          try {
            res = await props.IsCellcomNumber({ phoneNumber });
            setResponse({ res: res.payload, kind: planSelectionRadioEnums.HAS_LINE_IN_CELLCOM.value });
            if (!res.payload.isSuccess) {
              setShowPopup(true);
              return false;
            }
          } catch (error) {
            setShowPopup(true);
            return false;
          }
          break;
        case planSelectionRadioEnums.HAS_LINE_IN_OTHER_COMPANY.value:
          try {
            res = await props.IsExternalCompanyNumber({ phoneNumber });
            setResponse({ res: res.payload, kind: planSelectionRadioEnums.HAS_LINE_IN_OTHER_COMPANY.value });
            if (res.payload.isSuccess && res.payload.phoneOperatorName == 'CELL') {
              setShowPopup(true);
              return false;
            }
          } catch (error) {
            setShowPopup(true);
            return false;
          }
          break;
        case planSelectionRadioEnums.INTRESTED_IN_NEW_LINE.value:
          props.setLineNumber(phoneNumber);
          break;
        default:
          break;
      }

    } else {
      if (plan !== planSelectionRadioEnums.INTRESTED_IN_NEW_LINE.value) {
        setResponse({ res: null, kind: planSelectionRadioEnums.HAS_LINE_IN_OTHER_COMPANY.value });
        setShowPopup(true);
        return false;
      }
    }
    dwhReport({
      ...dwhDictionary.SelectedPackage_ContinueClicked,
      param4: props.idfStore.selectedPackage.offerID,
      param5: props.idfStore.selectedPackage.price,
      param6: phoneNumber
    });
    return true;
  };

  const onSelectedPackages = (selectedPackage) => {
    props.setSelectedPackage(selectedPackage);
    dwhReport({
      ...dwhDictionary.SelectedPackage,
      param4: selectedPackage.offerID,
      param5: selectedPackage.price,
    });
  };

  const onClickAllPackages = () => {
    // TODO: add validation for phone number
  };

  const onRadioBtnChange = (key) => {
    props.setLineType(key);
    setPlan(key);
  };


  const handleNewInputChange = (e) => {
    if (e.target.value.length > 10) return;
    else {
      props.setLineNumber(e.target.value);
    }
  };

  return (
    <div className='idf-plan-selection step'>
      <Container fluid className='idf-step-header justify-content-center d-flex flex-column align-items-center'>
        <Row className='idf-title-bold justify-content-center d-flex'>{props.contentData.planSelectionTitle.value}</Row>
        <Row className='idf-title-marketing-regular  justify-content-center d-flex'>{props.contentData.planSelectionSubTitle.value}</Row>
      </Container>
      <Container fluid className='idf-sale-packages-container'>
        <SalePackages
          packages={{
            expandedValue: packagesPostFunding,
            isAbroadPackages: false,
          }}
          isSwiper={true}
          isHideButton={true}
          onSelectedPackages={onSelectedPackages}
          isIdf={true}
        />
      </Container>
      <Container fluid className='idf-plan-selection-radio-container'>
        <Container fluid className='plan-selection-header justify-content-center d-flex flex-column align-items-center'>
          <Row className='idf-sub-title-bold  justify-content-center d-flex'>מה קו הטלפון עבורו נדרש השירות?</Row>
        </Container>
        {Object.entries(planSelectionRadioEnums).map(([key, value], i) => {
          return (
            <div className='radio-input-container' key={i}>
              <RadioInput
                checked={props.idfStore.lineType === value.value}
                id={'radioLineType' + i}
                name={'lineType'}
                value={key}
                label={value.title}
                onChange={() => onRadioBtnChange(value.value)}
              />
              {props.idfStore.lineType === value.value && (
                <>
                  {value != planSelectionRadioEnums.INTRESTED_IN_NEW_LINE ? (
                    <div className='checked-new-input'>
                      <span className='checked-new-input-title'>איזה מספר אנחנו מניידים?</span>
                      <TextInput
                        onChange={(e) => handleNewInputChange(e)}
                        value={props.idfStore.lineNumber}
                        name='id'
                        type='tel'
                        placeholder='מספר הטלפון אותו תרצו לנייד'
                        required='required'
                      />
                    </div>
                  ) : (
                    <div className='checked-new-input disabled'>
                      <span className='checked-new-input-title'>
                        מספר הקו החדש שלך הוא {'0' + props.idfStore.userDetails.new_line_code}
                      </span>
                    </div>
                  )}
                </>
              )}
            </div>
          );
        })}
      </Container>
      <Buttons onClickNavigation={() => onContinue()} canContinue={canContinue} hideBackButton={true} />
      <PopUp preventWrapperClose={true} showPopUp={showPopup} onClose={() => setShowPopup(false)} className=''>
        <PhoneNumberErrorPopUp data={response} setShowPopUp={setShowPopup} />
      </PopUp>
    </div>
  );
};
const mapStateToProps = (state) => ({
  idfStore: state.idfSale,
});

const mapDispatchToProps = {
  IsCellcomNumber,
  IsExternalCompanyNumber,
};

export default connect(mapStateToProps, mapDispatchToProps)(PlanSelection);
